export const dateToLocalISO = function (timeStamp: number, timeZone: number) {
  // off为当地时区相对UTC的偏移量，日本为9，中国为8
  const off = -timeZone * 60;
  const absoff = Math.abs(off);
  return `${
    new Date(timeStamp * 1000 - off * 60 * 1000).toISOString().substr(0, 23) +
    (off > 0 ? '-' : '+') +
    (absoff / 60).toFixed(0).padStart(2, '0')
  }:${(absoff % 60).toString().padStart(2, '0')}`;
};

/**
 * @Description
 *
 * Get Today and Monday date (yyyy-mm-dd)
 * Used for KEP collection page modified date experiment
 * */
export const getTodayAndMondayDate = (): {
  today: string;
  monday: string;
  todayInSlashFormat: string;
  mondayInSlashFormat: string;
} => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 (Sun) to 6 (Sat)
  const monday = new Date(today); // Start with today
  // Calculate Monday
  const daysSinceMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  monday.setDate(today.getDate() - daysSinceMonday);
  const formatDate = (date: Date, useSlashFormat: boolean) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    if (useSlashFormat) {
      return `${year}/${month}/${day}`;
    } else {
      return `${year}-${month}-${day}`;
    }
  };
  return {
    today: formatDate(today, false),
    monday: formatDate(monday, false),
    todayInSlashFormat: formatDate(today, true),
    mondayInSlashFormat: formatDate(monday, true),
  };
};
